export default __webpack_public_path__ + "static/media/Checkmark-white.dda63d66.svg";